import React from 'react'
import numeral from 'numeral'
import './table.css'
 function table({countries}) {
    return (
<div className="table_data">
  {
      countries.map(({country,cases})=>(
            <tr>
                <td>{country}</td>
                <td>{numeral(cases).format("0,0")}</td>
            </tr>
      ))
  }


</div>
      


    )
}

export default table
